module.exports = __webpack_public_path__ + "static/media/2017-logo-500x500.d731769d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared-components/2017-logo-500x500.png
// module id = 1660
// module chunks = 0